module.exports = new Promise(resolve => {
    const hostname = window.location.hostname
    let remoteUrl = 'https://'

    if (!hostname.includes('local')) {
      remoteUrl += 'oms-'
    }

    remoteUrl += hostname

    if (hostname.includes('local')) {
      remoteUrl += ':3005'
    }

    remoteUrl += '/omsRemoteEntry.js'

    if (hostname.includes('rotw.uplight.io')) {
      const envName = hostname.split('.')[1]
      remoteUrl = 'https://storage.googleapis.com/oms-upsuite-' + envName + '-rotw/build/omsRemoteEntry.js'
    }

    if (hostname.includes('upsuite.uplightplatform.com')) {
      remoteUrl = 'https://storage.googleapis.com/oms-upsuite-prd-rotw/build/omsRemoteEntry.js'
    }

    const script = document.createElement('script')
    script.src = remoteUrl
    script.onload = () => {
      const proxy = {
        get: (request) => window.oms.get(request),
        init: (arg) => {
          try {
            return window.oms.init(arg)
          } catch(e) {
            console.log('oms remote container already initialized')
          }
        }
      }
      resolve(proxy)
    }
    document.head.appendChild(script);
  })
  ;